/**
 * Источник сторис через настоящие ручки из `contract.ts`. Mock
 * (`mocks/store.ts`) — только при `VITE_STORIES_MOCK=true`.
 */
import type { ApiClient } from '../client'
import type { PublicStoryDto, StoryDto, StoryMediaDto } from './contract'
import type { StoriesBackend } from './mocks/store'

export function createHttpStoriesBackend(api: ApiClient): StoriesBackend {
  return {
    list: async () => (await api.get<{ items?: StoryDto[] }>('/admin/stories')).items ?? [],
    get: (id) => api.get<StoryDto>(`/admin/stories/${id}`),
    create: (input) => api.post<StoryDto>('/admin/stories', input),
    update: (id, input) => api.put<StoryDto>(`/admin/stories/${id}`, input),
    remove: async (id) => {
      await api.del<unknown>(`/admin/stories/${id}`)
    },
    upload: (file) => {
      const form = new FormData()
      form.append('file', file)
      return api.post<StoryMediaDto>('/admin/stories/media', form)
    },
    published: async () => (await api.get<{ items?: PublicStoryDto[] }>('/stories')).items ?? [],
    view: async (id) => {
      await api.post<unknown>(`/stories/${id}/view`)
    },
  }
}
